"use client";
import AppLayout from "@/components/app/applayout";
import InvestmentOnly from "@/components/investments/investment";
import Explore from "@/components/listings/explore";
import ListingsPage from "@/components/listings/listingsContent";
import { propertyType, pxToRem } from "@/util";
import { Box } from "@mui/material";
import { useSearchParams } from "next/navigation";
import React from "react";
import { makeStyles } from "tss-react/mui";

export default function Listings() {
  const { classes } = styles();
  const searchParams = useSearchParams();
  const currentPage = searchParams.get("type");

  return (
    <AppLayout>
      <Box className={classes.container}>
        <Explore pageName={currentPage || ""} />
        {/* <Property /> */}
        {currentPage === propertyType.INVESTMENT && <InvestmentOnly />}
        {currentPage === propertyType.LISTING && <ListingsPage />}
      </Box>
    </AppLayout>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minHeight: pxToRem(500),
    gap: theme.spacing(4),
    paddingBottom: `${pxToRem(10)}`,
  },
}));
